<template>
  <textarea v-model="model" class="c-text-area"/>
</template>

<script setup lang="ts">
  const model = defineModel();
</script>

<style lang="scss">
  .c-text-area {
    min-height: 6rem;
    outline: none;
    border: none;
    color: inherit;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;

    &::placeholder {
      color: $input-placeholder;
      font-weight: 400;
    }

    .c-field-control:has(&) {
      cursor: text;
    }
  }
</style>